import { injectable, inject } from 'inversify';
import type { IPanelPagoRepository } from '@/domain/repositories/IPanelPagoRepository';
import { PanelPago } from '@/domain/entities/PanelPago';
import { TYPES } from '@/di/tokens';

@injectable()
export class CancelPanelPagoAction {
  constructor(
    @inject(TYPES.IPanelPagoRepository) private panelPagoRepository: IPanelPagoRepository
  ) {}

  async execute(id: number): Promise<PanelPago> {
    return await this.panelPagoRepository.cancel(id);
  }
}
